import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { WalPageService } from './wal-page.service';
import { DataExchangeService } from './data-exchange.service';
import { ISessionDetails } from '../../interfaces/session-details';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class SessionAuthService {

  private readonly router = inject(Router);
  private readonly walPageService = inject(WalPageService);
  private readonly dataExchangeService = inject(DataExchangeService);  
  private readonly logger = inject(NGXLogger);

  constructor() { }

  // This is a two step process
  // Step 1: Obtain a temporary auth token using basic auth; the token has just one privilege - PRIV_WAL_UI_SESSION
  public getWalPageSession(region: string, sessionId: string): Observable<void> {
    // this.logger.log('getWalPageSession getTempAuthToken - before', new Date().toISOString());       
    // // get a temp auth token
    // return this.walPageService.getTempAuthToken().pipe(
    //   switchMap(response => {
    // this.logger.log('getWalPageSession getTempAuthToken - after', new Date().toISOString());       
    //     this.dataExchangeService.setTempToken(response.accessToken);
    //   // Get session details
    //   return this.getSessionDetails(region, sessionId);
    //   }),
    //   catchError(error => {
    //     this.dataExchangeService.setMessageText(error);
    //   return throwError(() => new Error(error));
    //   })
    // );

    // Get session details - no more temp token needed as the endpoint is not protected (auth token is only needed for the subsequent API calls)
    return this.getSessionDetails(region, sessionId);
  }  

  // Step 2: Get the session details, including a permanent auth token for all other requests
  public getSessionDetails(region: string, sessionId: string): Observable<void> {
    return this.walPageService.getSessionDetails(region, sessionId).pipe(
      map(response => {
        this.dataExchangeService.setSession(response);
        if (response) {
          this.dataExchangeService.setSession(response);
          const sessionDetails: ISessionDetails = response;
          let brandCode: string = sessionDetails.brandCode || '';
          this.dataExchangeService.setBrandCode(brandCode);
          // Find out the auth token
          if (sessionDetails.options) {
            const options: Map<string, string> = new Map(Object.entries(sessionDetails.options));
            if (options.has('auth')) {
              const authToken: string = options.get('auth') || '';
              this.dataExchangeService.setAuthToken(authToken);
              this.logger.log('getWalPageSession getSessionDetails - auth token', authToken);       
            }
          }
        }
      }),
      catchError(error => {
        this.dataExchangeService.setMessageText(error);
        throw error;
      })
    );
  }

}
